import { render, staticRenderFns } from "./virtualContract.vue?vue&type=template&id=50276812&scoped=true"
import script from "./virtualContract.vue?vue&type=script&lang=js"
export * from "./virtualContract.vue?vue&type=script&lang=js"
import style0 from "./virtualContract.vue?vue&type=style&index=0&id=50276812&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50276812",
  null
  
)

export default component.exports